import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/assessments/$assessmentId/compare/$comparisonId",
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <div>Hello "/assessments/$assessmentId/compare/$comparisonId"!</div>;
}
